import React, { useEffect, useState } from "react";
import Footer from "./Footer";
import Navbar from "./Navbar_old";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Modal } from "react-bootstrap";
import apiService from "../services/apiService";

const Notification = () => {
  const loggedUser = JSON.parse(localStorage.getItem("currentUser"));
  const [notifications, setNotifications] = useState([]);
  const [filter, setFilter] = useState("all");
  const [loading, setLoading] = useState(true);
  const [modalImage, setModalImage] = useState(null);

  // Time ago helper
  const timeAgo = (date) => {
    const seconds = Math.floor((new Date() - new Date(date)) / 1000);
    const intervals = [
      { label: "year", value: 31536000 },
      { label: "month", value: 2592000 },
      { label: "day", value: 86400 },
      { label: "hour", value: 3600 },
      { label: "minute", value: 60 },
    ];
    for (let i of intervals) {
      const count = Math.floor(seconds / i.value);
      if (count > 0) return `${count} ${i.label}${count > 1 ? "s" : ""} ago`;
    }
    return "Just now";
  };

  // Get image helper
  const getImageUrl = (img) => {
    const defaultAvatar = "https://cdn-icons-png.flaticon.com/512/149/149071.png";
    if (!img || img.trim() === "") return defaultAvatar;
    return apiService.getImageUrl(img) || defaultAvatar;
  };

  // Fetch notifications
  const fetchNotifications = async () => {
    try {
      const res = await apiService.getNotifications(loggedUser._id);
      if (res.success) {
        const sorted = res.notifications.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );
        setNotifications(sorted);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
    const interval = setInterval(fetchNotifications, 5000);
    return () => clearInterval(interval);
  }, []);

  // Handle Like
  const handleLike = async (note) => {
    try {
      await apiService.sendLike(loggedUser._id, note.from_user_id);

      const stored = JSON.parse(localStorage.getItem("likedProfiles")) || [];
      const exists = stored.some((p) => p.id === note.from_user_id);

      if (!exists) {
        stored.push({
          id: note.from_user_id,
          fullName: note.from_name,
          avatar: note.from_image,
        });
        localStorage.setItem("likedProfiles", JSON.stringify(stored));
      }

      alert("❤️ Liked!");
    } catch (err) {
      console.error(err);
    }
  };

  const filteredNotifications = notifications.filter(
    (n) => filter === "all" || n.type === filter
  );

  if (loading)
    return <div className="text-light text-center py-5">Loading...</div>;

  return (
    <>
      <div className="navbar-fixed">
        <Navbar />
      </div>

      <div className="container py-3 profile mt-5 pt-5">

        {/* FILTER BUTTONS */}
        <div className="d-flex gap-2 mb-4 justify-content-center flex-wrap">
          {["all", "chat", "like"].map((t) => (
            <button
              key={t}
              className={`btn btn-sm rounded-pill px-4 py-2 fw-semibold ${
                filter === t ? "btn-warning text-dark" : "btn-outline-warning text-white"
              }`}
              onClick={() => setFilter(t)}
            >
              {t.toUpperCase()}
            </button>
          ))}
        </div>

        {/* NOTIFICATIONS */}
        <div className="d-flex flex-column gap-3" style={{ maxHeight: "70vh", overflowY: "auto" }}>
          {filteredNotifications.length === 0 && (
            <div className="text-center text-light py-5">No notifications yet.</div>
          )}

          {filteredNotifications.map((note) => {
            const isLike = note.type === "like";
            const likedProfiles = JSON.parse(localStorage.getItem("likedProfiles")) || [];
            const alreadyLiked = likedProfiles.some((p) => p.id === note.from_user_id);

            return (
              <div
                key={note._id}
                className="d-flex align-items-center gap-3 p-3 rounded-4 shadow-sm notification-card"
                style={{
                  minHeight: "80px",
                  background: isLike
                    ? "linear-gradient(135deg, #000000, #000000)"
                    : "linear-gradient(135deg, #000000, #003366)",
                  color: "#fff",
                  cursor: "pointer",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                }}
              >
                <img
                  src={getImageUrl(note.from_image)}
                  onError={(e) =>
                    (e.target.src = "https://cdn-icons-png.flaticon.com/512/149/149071.png")
                  }
                  alt={note.from_name}
                  className="rounded-circle border border-2 border-white shadow-sm"
                  width="50"
                  height="50"
                  style={{ objectFit: "cover", cursor: "pointer" }}
                  onClick={() => setModalImage(getImageUrl(note.from_image))}
                />

                <div className="flex-grow-1">
                  <div className="d-flex align-items-center gap-2">
                    <b>{note.from_name}</b>
                    {isLike && (
                      <i
                        className={`bi ${
                          alreadyLiked ? "bi-heart-fill text-danger" : "bi-heart text-light"
                        }`}
                        style={{ fontSize: "1.1rem", cursor: "pointer" }}
                        onClick={() => handleLike(note)}
                      />
                    )}
                  </div>
                  <div style={{ fontSize: "0.85rem", opacity: 0.9 }}>
                    {note.message || (isLike ? "Liked your profile ❤️" : "Sent a message")}
                  </div>
                </div>

                <span className="ms-auto text-light" style={{ fontSize: "0.75rem" }}>
                  {timeAgo(note.created_at)}
                </span>
              </div>
            );
          })}
        </div>
      </div>

      {/* MODAL FOR DP */}
      <Modal show={!!modalImage} onHide={() => setModalImage(null)} centered size="lg">
        <Modal.Body className="p-0">
          <img src={modalImage} alt="Profile" className="w-100" />
        </Modal.Body>
      </Modal>

      <Footer />
    </>
  );
};

export default Notification;
